import type { Shema } from '../api/odjemalec';

/** Sklanjanje za {@code koliko}: 1 prejemnik, 2 prejemnika, 3 prejemniki, 5 prejemnikov. */
export const PREJEMNIKI: [string, string, string, string] = ['prejemnik', 'prejemnika', 'prejemniki', 'prejemnikov'];

/** Naslovi skrite kopije (okrožnice), na strežniku shranjeni ločeni z », «. */
export function skritaKopija(s: Shema['EpostaSporocilo']): string[] {
  return s.skritaKopija ? s.skritaKopija.split(/,\s*/).filter(Boolean) : [];
}

const ZNAKI: Record<string, string> = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: ' ', ndash: '–' };

/** Zadeva iz {@code <title>} naložene datoteke HTML (prazno, če je ni). */
export function zadevaIzHtml(html: string): string {
  const m = /<title[^>]*>([\s\S]*?)<\/title>/i.exec(html);
  return (m?.[1] ?? '')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/&(#x[0-9a-f]+|#[0-9]+|[a-z]+);/gi, (z, k: string) =>
      k[0] === '#'
        ? String.fromCodePoint(
            parseInt(k[1] === 'x' || k[1] === 'X' ? k.slice(2) : k.slice(1), k[1] === 'x' || k[1] === 'X' ? 16 : 10),
          )
        : (ZNAKI[k.toLowerCase()] ?? z),
    );
}
